import React from "react";
import { DeleteModalComponent, StandardTableComponent, TableEditActionComponent, TableDeleteActionComponent } from "../basics/table";
import Website from "../../models/website/Website";
import { Badge, ListGroup, Tab } from "react-bootstrap";
import { Application, CountryHelper, CheckPermissions, GeneralSettingsHelper } from "../../helpers";
import UserRolesEnum from "../../enums/UserRolesEnum";
import { NewsRepository, WebsiteRepository } from "../../repository";
import FormToastComponent from "../basics/FormToastComponent";
import { FormattedMessage } from "react-intl";
import FormattedMessageString from "../basics/FormattedMessageString";
import Module from "../../models/module/Module";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import ToolTipLink from "../basics/ToolTipLink";
import LoaderComponent from "../basics/layout/LoaderComponent";

class NewsOverviewTableComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            rows: this.props.rows,
            settings: Module.getSettings(),
            website: null,
            isLoading: true,
            language: Application.tableLanguage()
        };

    }

    componentDidMount() {
        WebsiteRepository.get(Website.get()).then(result => {
            this.setState({
                website: result,
                isLoading: false
            })
        })
    }

    columns(index) {
        return [
            {
                dataField: 'id',
                hidden: true
            },
            {
                dataField: 'title',
                text: <FormattedMessageString id="CMS.News.overview.table.title" />,
                sort: true,
                isDummyField: true,
                formatter: (cellContent, row) => {
                    let content = row.news.contents[index];
                    return content ? content.title : null;
                }
            },
            this.state.settings.use_categories ?
                {
                    dataField: 'category',
                    text: <FormattedMessageString id="CMS.News.overview.table.category" />,
                    sort: true,
                    sortFunc: (a, b, order, dataField, rowA, rowB) => {
                        let contentsA = rowA.news.contents[index];
                        let contentsB = rowB.news.contents[index];

                        if (order === 'asc')
                            return contentsA.category.full_title.toLowerCase() < contentsB.category.full_title.toLowerCase() ? -1 : 1;
                        else if (order === 'desc')
                            return contentsB.category.full_title.toLowerCase() > contentsA.category.full_title.toLowerCase() ? 1 : -1;
                    },
                    formatter: (cellContent, row) => {
                        let content = row.news.contents[index];
                        return content.category ? content.category.full_title : null;
                    }
                } :
                {},
            this.state.settings.show_date ? {
                dataField: 'published_at',
                text: <FormattedMessageString id="CMS.News.overview.table.published_at" />,
                sort: true,
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    let dateA = rowA.news.published_at;
                    let dateB = rowB.news.published_at;

                    if (order === 'asc')
                        return Date.parse(dateA) - Date.parse(dateB);
                    else if (order === 'desc')
                        return Date.parse(dateB) - Date.parse(dateA);
                },
                isDummyField: true,
                formatter: (cellContent, row) => {
                    return row.news.published_at ? moment(row.news.published_at).format('DD/MM/YYYY HH:mm') : null;
                }
            } : {},
            {
                dataField: 'updated',
                text: <FormattedMessageString id="CMS.News.overview.table.last_updated" />,
                isDummyField: true,
                sort: true,
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    let contentsA = rowA.news.contents[index];
                    let contentsB = rowB.news.contents[index];

                    if (order === 'asc') {
                        return Date.parse(contentsA.updated_at) - Date.parse(contentsB.updated_at)
                    }
                    else if (order === 'desc') {
                        return Date.parse(contentsB.updated_at) - Date.parse(contentsA.updated_at)
                    }
                },
                formatter: (cellContent, row) => {
                    let contents = row.news.contents[index];
                    if (contents === undefined) return null;
                    return (
                        <div className="updated_by">
                            {moment(contents.updated_at).format('DD/MM/YYYY HH:mm:ss')}
                            {contents.updated_by && (<><br /><span className="small-highlighted-text"><FormattedMessageString id="CMS.Pages.overview.table.updated_by" /> {contents.updated_by}</span></>)}
                        </div>
                    )
                }
            },
            {
                dataField: 'views',
                text: '',
                sort: false,
                isDummyField: true,
                editable: false,
                headerStyle: (colum, colIndex) => {
                    return { width: '1%' };
                },
                formatter: (cellContent, row) => {
                    let contents = row.news.contents[index];

                    return (
                        <div className="actions">
                            {contents && !GeneralSettingsHelper.is() ?
                                <Badge>
                                    <FontAwesomeIcon icon={['fas', 'fa-chart-column']} className="mr-1" />
                                    {contents.views}
                                </Badge>
                                : null
                            }
                        </div>
                    )
                }
            },
            {
                dataField: 'actions',
                isDummyField: true,
                text: <FormattedMessage id="CMS.Table.actions" />,
                hidden: !CheckPermissions.role(this.props.user.roles, UserRolesEnum.EDITOR),
                sort: false,
                editable: false,
                headerStyle: (colum, colIndex) => {
                    return { width: '10%' };
                },
                formatter: (cellContent, row) => {
                    let content = row.news.contents[index];

                    return <div className="actions actions-end">
                        {this.state.settings.show_photoalbum && (
                            <ToolTipLink className="default" to={"photoalbum/" + row.id}
                                title={"CMS.News.overview.tooltip.show_photoalbum"}>
                                <FontAwesomeIcon icon={['far', 'images']} size="lg" />
                            </ToolTipLink>
                        )}
                        {this.state.settings.show_videoalbum && (
                            <ToolTipLink className="default" to={"videoalbum/" + row.id + (content !== undefined ? '/' + content.language : '/')}
                                title={"CMS.News.overview.tooltip.show_videoalbum"}>
                                <FontAwesomeIcon icon={['far', 'video-plus']} size="lg" />
                            </ToolTipLink>
                        )}
                        {CheckPermissions.role(this.props.user.roles, UserRolesEnum.EDITOR) && !GeneralSettingsHelper.is() && (
                            row.news.active ?
                                <Link onClick={(event) => this.toggleActive(event, row)} className="active" to="#">
                                    <FontAwesomeIcon icon={['fas', 'check']} />
                                </Link>
                                :
                                <Link onClick={(event) => this.toggleActive(event, row)} className="inactive" to="#">
                                    <FontAwesomeIcon icon={['fas', 'times']} />
                                </Link>
                        )}
                        {CheckPermissions.role(this.props.user.roles, UserRolesEnum.EDITOR) && !GeneralSettingsHelper.is() && (
                            <TableEditActionComponent id={row.news.id} custom={content !== undefined ? '/' + content.language : '/'} />
                        )}
                        {CheckPermissions.role(this.props.user.roles, UserRolesEnum.EDITOR) && !GeneralSettingsHelper.is() && (
                            <TableDeleteActionComponent row={row} parent={this} />
                        )}
                    </div >
                }
            }
        ];
    }

    updateData = () => NewsRepository.all().then(response => this.props.parent.setState({ rows: response }));

    table(index) {
        return (
            <div className={"custom-data-table news"}>
                <StandardTableComponent keyField="id" data={this.state.rows} columns={this.columns(index)} search={false}
                    title={this.props.title_id} type={this.props.type}
                    subRows={false}
                    sort={{
                        dataField: 'published_at',
                        order: 'desc'
                    }} />
                <DeleteModalComponent parent={this} />
            </div>
        )
    }

    render() {
        if (this.state.isLoading) return <LoaderComponent />;
        if (this.state.reload) return <LoaderComponent />;

        return (
            <div className="tab-tables">
                <Tab.Container id={"list-group-language-newss"}
                    defaultActiveKey={"#" + (this.state.website.languages[this.state.language] !== undefined ? this.state.website.languages[this.state.language].language : this.state.website.languages[0].language)}>
                    <ListGroup>
                        {
                            this.state.website.languages.map((language, index) => {
                                return (
                                    <ListGroup.Item action href={"#" + language.language} key={index}
                                        onClick={() => this.setState({ language: index }, () => Application.setTableLanguage(index))}>
                                        {CountryHelper.getLanguages().find(({ value }) => value + "" === language.language + "").label}
                                    </ListGroup.Item>
                                )
                            })
                        }
                    </ListGroup>
                    <Tab.Content>
                        {
                            this.state.website.languages.map((language, index) => {
                                return <Tab.Pane eventKey={"#" + language.language} key={index}>
                                    {this.table(index)}
                                </Tab.Pane>

                            })
                        }
                    </Tab.Content>
                </Tab.Container>
            </div>
        );
    }

    toggleActive(event, _row) {
        NewsRepository.toggle(_row.news.id)
            .then(response => {
                let newRows = [...this.state.rows];
                newRows = newRows.map((row) => {
                    if (row.news.id === _row.news.id) {
                        let news = row.news;
                        news.active = response;
                        return {
                            ...row,
                            news: news
                        }
                    }
                    return row;
                })
                this.setState(curr => ({ ...curr, rows: newRows, reload: true }), () => {
                    this.setState({ reload: false })
                });
            })
            .catch(error => {
                FormToastComponent.errorTrans('CMS.News.overview.toggle.failed')
            })
    }
}

export default NewsOverviewTableComponent;
